import firebase from "firebase/app"

const service = {
  version: '2021.02.01',
  url: '/service',
  geoUrl: 'https://wft-geo-db.p.rapidapi.com/v1/geo',
  geoApiKey: '3150569f16msh1aab4c2cd28fcd4p13d52bjsnc466038f1d05',
  geoLimit: 50,
  async getRequest(url, param) {
    try {
      const res = await fetch(`${this.url}${url}`, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(param),
      })
      return await res.json()
    } catch (e) {
      this.log('service get failed.')
      this.log(url)
      this.log(e)
      return {
        isError: true,
        message: e,
      }
    }
  },
  async search(area, likes, uid, action) {
    return await this.getRequest('/posts/search', {
      type: 'q',
      area: area,
      likes: likes,
      uid: uid,
      action: action,
    })
  },
  async getUserLikes(uid) {
    return await this.getRequest('/posts/search', {
      type: 'u',
      uid: uid,
    })
  },
  async getBookmarks(uid) {
    return await this.getRequest('/posts/search', {
      type: 'b',
      uid: uid,
    })
  },
  async getPost(pid, uid, fromPath) {
    return await this.getRequest('/posts/search', {
      type: 'p',
      pid: pid,
      uid: uid,
      fromPath: fromPath,
    })
  },
  async getGeoData(path) {
    const res = await fetch(
      `${this.geoUrl}${path}`,
      {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          'x-rapidapi-host': 'wft-geo-db.p.rapidapi.com',
          'x-rapidapi-key': this.geoApiKey,
        },
      }
    )
    const json = await res.json()
    return json.data
  },
  async getCountryList(prefix) {
    return this.getGeoData(`/countries?namePrefix=${prefix}&limit=${this.geoLimit}`)
  },
  async getRegionList(countryCode, prefix) {
    return this.getGeoData(`/countries/${countryCode}/regions?namePrefix=${prefix}&limit=${this.geoLimit}`)
  },
  async getCityList(countryCode, regionCode, prefix) {
    return this.getGeoData(`/countries/${countryCode}/regions/${regionCode}/cities?namePrefix=${prefix}&limit=${this.geoLimit}`)
  },
  async getCityListFromCityPrefix(prefix) {
    return this.getGeoData(`/cities?namePrefix=${prefix}&limit=${this.geoLimit}&sort=-population`)
  },
  getFlagCode(countryCode) {
    const s1 = (165 + countryCode.charCodeAt(0)).toString(16)
    const s2 = (165 + countryCode.charCodeAt(1)).toString(16)
    return `&#x1f1${s1};&#x1f1${s2};`
  },
  /**
   * (private) Access Token取得
   *
   * @param {String} uid firebase uid
   */
  async __getToken(uid) {
    const db = firebase.firestore()
    const doc = await db.collection('tokens').doc(uid).get()
    const data = doc.data()
    this.log('__ get token:', data)
    return !data ? '' : data.value
  },
  /**
   * Access Token取得
   *
   * @param {String} uid firebase uid
   * @returns {String} Access Token
   */
  async getToken(uid) {
    const token = await this.__getToken(uid)
    if (!!token) {
      return token
    }
    // firebaseから取得できなかった場合は初期化
    return await this.resetToken(uid)
  },
  /**
   * Access Tokenをリセットして返却します。
   *
   * @param {String} uid firebase uid
   * @return {String} Access Token
   */
  async resetToken(uid) {
    await this.getRequest('/others/init_token', {
      uid: uid,
    })
    return await this.__getToken(uid)
  },
  async setProfile(profile) {
    const paikeoutAreas = []
    if (profile.paikeoutArea1.cityId) {
      paikeoutAreas.push(profile.paikeoutArea1)
    }
    if (profile.paikeoutArea2.cityId) {
      paikeoutAreas.push(profile.paikeoutArea2)
    }
    if (profile.paikeoutArea3.cityId) {
      paikeoutAreas.push(profile.paikeoutArea3)
    }
    profile.paikeoutAreas = paikeoutAreas
    return this.getRequest('/users/add', {
      uid: profile.uid,
      email: profile.email,
      birthday: profile.birthday,
      nickname: profile.nickname,
      passionEmoji: profile.passionEmoji,
      gender: profile.gender,
      school: profile.school,
      comment: profile.comment,
      photoUrl: profile.photoUrl,
      thumbnailUrl: profile.thumbnailUrl,
      whereLive: profile.whereLive,
      paikeoutAreas: paikeoutAreas,
      canSpeakLanguages: profile.canSpeakLanguages,
      languagesUnderStudy: profile.languagesUnderStudy,
      character: profile.character,
      isSetName: !profile.firstName || !profile.lastName ? 0 : 1,
      isSetPhoneNumber: !profile.phoneNumber ? 0 : 1,
      authProvider: profile.authProvider,
      token: await this.getToken(profile.uid),
    })
  },
  async uploadProfilePhoto(uid, blob) {
    const form = new FormData()
    form.append('uid', uid)
    form.append('photo', blob, 'profile photo')
    form.append('token', await this.getToken(uid))
    const res = await fetch('/service/users/add_photo', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      body: form,
    })
    return await res.json()
  },
  async addUserList(uid, listType, val) {
    const list = Array.isArray(val)
      ? val
      : [val]
    return this.getRequest('/users/add_to_list', {
      uid: uid,
      listType: listType,
      list: list,
      token: await this.getToken(uid),
    })
  },
  async setUserList(uid, listType, val) {
    const list = Array.isArray(val)
      ? val
      : [val]
    return this.getRequest('/users/replace_list', {
      uid: uid,
      listType: listType,
      list: list,
      token: await this.getToken(uid),
    })
  },
  async getFacebookPhoto(uid, facebookUid) {
    return this.getRequest('/users/get_facebook_photo', {
      uid: uid,
      facebookUid: facebookUid,
    })
  },
  async post(uid, pid, likeCode, mainPhotoId, mainPhotoUrl, photos, comment) {
    return this.getRequest('/posts/add', {
      pid: pid,
      uid: uid,
      likeCode: likeCode,
      mainPhotoId: mainPhotoId,
      mainPhotoUrl: mainPhotoUrl,
      photos: photos,
      comment: comment,
      postFrom: 'web',
      token: await this.getToken(uid),
    })
  },
  async postDelete(uid, pid) {
    return this.getRequest('/posts/del', {
      pid: pid,
      uid: uid,
      token: await this.getToken(uid),
    })
  },
  async getPostDetail(uid, pid) {
    return this.getRequest('/posts/get', {
      pid: pid,
      uid: uid,
    })
  },
  async getPostInfo(uid, pid) {
    return this.getRequest('/posts/info', {
      pid: pid,
      uid: uid,
    })
  },
  async postNewPhoto(uid, files) {
    const form = new FormData()
    form.append('uid', uid)
    form.append('token', await this.getToken(uid))
    for (let i = 0 ; i < files.length ; i++) {
      form.append(`file-${i}`, files[i], files[i].name)
    }
    const res = await fetch('/service/posts/add_photo', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      body: form,
    })
    return await res.json()
  },
  async postEditPhoto(uid, id, blob) {
    const form = new FormData()
    form.append('uid', uid)
    form.append('id', id)
    form.append('file', blob, 'edit')
    form.append('token', await this.getToken(uid))
    const res = await fetch('/service/posts/edit_photo', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      body: form,
    })
    return await res.json()
  },
  async addComment(rid, uid, toUid, cid, comment) {
    try {
      return this.getRequest('/chats/add', {
        rid: rid,
        uid: uid,
        toUid: toUid,
        cid: cid,
        comment: comment,
      })
    } catch (e) {
      try {
        await this.saveError(uid, 'addComment', e.message)
      } catch (ee) {
        this.log('addComment failed.')
        this.log(e)
        this.log(ee)
      }
    }
  },
  async readComment(rid, fromUid, toUid) {
    const json = await this.getRequest('/chats/set_read', {
      rid: rid,
      fromUid: fromUid,
      toUid: toUid,
    })
    return !json.isError
  },
  async hasUnread(uid, rid) {
    const json = await this.getRequest('/chats/has_unread', {
      uid: uid,
      rid: rid,
    })
    return json.res.hasUnread
  },
  async getRoomInfos(uid, list) {
    const json = await this.getRequest('/chats/has_unreads', {
      uid: uid,
      list: list,
    })
    return json.res
  },
  async doReport(uid, toUid, reason, wantUs, comment) {
    const json = await this.getRequest('/chats/report', {
      uid: uid,
      toUid: toUid,
      reason: reason,
      wantUs: wantUs,
      comment: comment,
    })
    return !json.isError
  },
  async doBlock(uid, blockedUid) {
    const json = await this.getRequest('/chats/set_block', {
      uid: uid,
      blockedUid: blockedUid,
    })
    return !json.isError
  },
  async getRoomId(uid, toUid) {
    //
    if (!uid) {
      // ログインしていない場合、Roomがあるかどうかわからない
      return ''
    }
    const json = await this.getRequest('/chats/get_room_id', {
      uid: uid,
      toUid: toUid,
    })
    return !json.res ? '' : json.res.rid
  },
  async isBookmark(uid, pid) {
    if (!uid) {
      // uidが空という事はログイン前なのでbookmarkできない.よってfalse.
      return false
    }
    const json = await this.getRequest('/bookmarks/is_bookmark', {
      uid: uid,
      pid: pid,
    })
    return json.res.res
  },
  async getBookmarkUsers(pid) {
    const json = await this.getRequest('/bookmarks/get-bookmark-users', {
      pid: pid,
    })
    return json.res
  },
  async setBookmark(uid, pid) {
    const json = await this.getRequest('/bookmarks/set', {
      uid: uid,
      pid: pid,
      token: await this.getToken(uid),
    })
    if (json.isError) {
      this.log(json.res)
    } else {
      return json.res.count
    }
  },
  async unsetBookmark(uid, pid) {
    const json = await this.getRequest('/bookmarks/un_bookmark', {
      uid: uid,
      pid: pid,
      token: await this.getToken(uid),
    })
    if (!json.isError) {
      return json.res.count
    }
  },
  async setLike(uid, pid) {
    const json = await this.getRequest('/likes/set', {
      uid: uid,
      pid: pid,
      token: await this.getToken(uid),
    })
    return !json.isError
  },
  async unsetLike(uid, pid) {
    const json = await this.getRequest('/likes/unset', {
      uid: uid,
      pid: pid,
      token: await this.getToken(uid),
    })
    return !json.isError
  },
  async isLike(uid, pid) {
    const json = await this.getRequest('/likes/is_like', {
      uid: uid,
      pid: pid,
    })
    return json.res.isLike
  },
  async checkLike(uid, clickUid) {
    const json = await this.getRequest('/likes/check', {
      uid: uid,
      clickUid: clickUid,
    })
    return !json.isError
  },
  async hasUnCheck(uid, rid) {
    const json = await this.getRequest('/likes/has_uncheck', {
      uid: uid,
    })
    return json.res.hasUncheck
  },
  async getOtherLiked(uid, pidList) {
    const json = await this.getRequest('/likes/get_other_liked', {
      uid: uid,
      pidList: pidList,
    })
    return json.res
  },
  async getOtherLikedByArea(countryCode, regionCode, cityId, pidList) {
    const json = await this.getRequest('/likes/get_other_liked_by_area', {
      countryCode: countryCode,
      regionCode: regionCode,
      cityId: cityId,
      pidList: pidList,
    })
    return json.res
  },
  async getAreaInfo(uid) {
    const data = await this.getRequest(`/area-info/${uid}`)
    const res = {
      whereLive: '',
      paikeoutAreas: [],
    }
    data.res.forEach(item => {
      switch (item.areaType) {
        case 'L':
          res.whereLive = item.displayArea
          break
        default:
          res.paikeoutAreas.push(item.displayArea)
      }
    })
    return res
  },
  async getMyProfile(uid) {
    const json = await this.getRequest('/users/get_my_profile', {
      uid: uid,
    })
    return json.res
  },
  async getUserProfileList(uid) {
    const json = await this.getRequest('/users/get_user_profile_list', {
      uid: uid,
    })
    return json.res
  },
  async getUserInfo(uid) {
    const json = await this.getRequest('/users/info', {
      uid: uid,
    })
    return json.res
  },
  async getUsersInfo(uids) {
    const json = await this.getRequest('/users/infos', {
      uids: uids,
    })
    return json.res
  },
  async getUserAreaInfo(uid) {
    const json = await this.getRequest('/users/user_area_info', {
      uid: uid,
    })
    return json.res
  },
  async getUsersAreas(country) {
    const json = await this.getRequest('/users/get_users_areas', {
      countryCode: country,
    })
    return json.res
  },
  async getSetting(key, uid) {
    const json = await this.getRequest('/settings/get', {
      key: key,
      uid: uid,
    })
    if (json.isError) {
      return ''
    }
    return json.res.value
  },
  async getPassions(param) {
    const json = await this.getRequest('/passions/get', param)
    return json.res
  },
  async isMatchVersion() {
    const version = await this.getSetting('version')
    if (!version) {
      return true
    }
    return version === this.version
  },
  authCheck() {
    return new Promise((resolve, reject) => {
      const u = firebase.auth().currentUser
      if (u) {
        // 認証状態がすぐに取得できた場合はそのままUIDを戻す
        resolve(u)
      } else {
        // 認証状態をすぐに取得できなかった場合は、リスナーをセット
        firebase.auth().onAuthStateChanged(async (user) => {
          if (user) {
            resolve(user)
          } else {
            reject('not login.')
          }
        })
      }
    })
  },
  async isProfileComplete(uid) {
    // プロフィールの登録状況を取得する
    // 必須項目がすべて埋まっていればtrue.
    const json = await this.getRequest('/users/is_profile_complete', {
      uid: uid,
    })
    return json.res.res
  },
  async saveError(uid, proc, message) {
    const res = await fetch(`${this.url}/save-error`, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify({
        uid: !uid ? 'none' : uid,
        proc: !proc ? 'none' : proc,
        message: JSON.stringify(message),
      }),
    })
    return await res.json()
  },
  async getPaikeoutSupportInfo() {
    let uid = 'VNAXk7utxggECv8Gw30iHpuRnFx1'
    if (process.env.NODE_ENV === 'development') {
      uid = 'prin2p8xaNc7AYzgjn1en6q40g23'
    }
    return {
      uid: uid,
      nickname: 'Paike Support Team',
      photoUrl: 'https://firebasestorage.googleapis.com/v0/b/paike-dev-01.appspot.com/o/users%2Fprin2p8xaNc7AYzgjn1en6q40g23%2Fphoto?alt=media&token=d523fbcf-2d1c-4046-9325-1e7792449000',
      latestComment: `Hello! We are Paike Support Team and here to help you😊
Please let us know if you have any questions by replying to this message👍`,
      modified: {
        seconds: new Date().getTime() / 1000,
      },
    }
  },
  getLikeGroupIcon(likeGroupCode) {
    switch (likeGroupCode) {
      case 's':
        return require('@/assets/images/likes/cake.svg')
      case 'f':
        return require('@/assets/images/likes/food.svg')
      case 'w':
        return require('@/assets/images/likes/sports.svg')
      case 'e':
        return require('@/assets/images/likes/fun.svg')
    }
  },
  getAge(birthdayStr) {
    return 1000
    /*
    年齢チェックは一旦廃止
    if (!birthdayStr) {
      return -1;
    }
    const birthday = new Date(birthdayStr)
    const today = new Date()
    const thisYearBirthday = new Date(
      today.getFullYear(), birthday.getMonth(), birthday.getDate())
    const age = today.getFullYear() - birthday.getFullYear()
    return today < thisYearBirthday ? age - 1 : age
    */
  },
  likeList: [{
    value: 'Sweets',
    text: 'Sweets',
    fillRule: '',
    clipRule: '',
    d: [
      'M31 20.5779C30.9984 20.3799 30.9427 20.2132 30.8592 20.062C30.7781 19.921 30.6694 19.79 30.5028 19.6885L30.5038 19.6869L21.0921 13.7089C20.4509 12.2323 19.2349 11.5044 18.431 11.5044C18.2437 11.5044 18.0329 11.5476 17.8133 11.6265L17.2257 11.2533L17.2228 11.2517C16.9118 11.0625 16.557 11.002 16.1766 11C15.7796 11.0007 15.3466 11.073 14.8915 11.2063C14.2097 11.4069 13.4794 11.7473 12.7865 12.2216C12.0946 12.6959 11.4405 13.3051 10.9283 14.0494C10.2212 15.0782 9.74039 16.1083 9.43566 17.0513C9.13093 17.9953 9.00064 18.8499 9 19.5455C9.00034 19.6676 9.00559 19.7835 9.01375 19.8964V26.9739C9.01409 27.8272 9.70538 28.5182 10.5584 28.5185H29.2694C30.1064 28.5182 30.7898 27.8527 30.8137 27.0171L30.9895 20.6784H30.9879C30.9915 20.645 31 20.6096 31 20.5779ZM20.1756 15.5485C20.1995 15.2732 20.3288 15.0581 20.4637 15.0683C20.5989 15.0784 20.6888 15.3102 20.6649 15.5858C20.6407 15.8608 20.5118 16.0758 20.3766 16.0653C20.2414 16.0552 20.1517 15.8238 20.1756 15.5485ZM19.6372 13.2507C19.7714 13.2313 19.9167 13.4369 19.9625 13.7099C20.0077 13.9832 19.936 14.2199 19.8021 14.2392C19.6682 14.2585 19.5226 14.0533 19.4768 13.7803C19.4316 13.5073 19.5033 13.2703 19.6372 13.2507ZM19.3164 17.4345C19.3403 17.1596 19.4692 16.9449 19.6048 16.955C19.7396 16.9651 19.8296 17.1966 19.8057 17.4719C19.7818 17.7472 19.6529 17.9622 19.5173 17.952C19.3822 17.9419 19.2921 17.7102 19.3164 17.4345ZM18.3158 15.5488C18.3399 15.2732 18.4689 15.0585 18.6041 15.069C18.739 15.0791 18.829 15.3108 18.8051 15.5858C18.7812 15.8611 18.6519 16.0762 18.517 16.0657C18.3818 16.0555 18.2919 15.8241 18.3158 15.5488ZM17.8143 17.4372C17.8601 17.7102 17.7884 17.9468 17.6542 17.9661C17.5203 17.9854 17.3747 17.7802 17.3292 17.5072C17.2837 17.2342 17.355 16.9972 17.4896 16.9779C17.6234 16.9583 17.7684 17.1642 17.8143 17.4372ZM16.9963 13.7852C17.0225 13.5099 17.1531 13.2958 17.2882 13.3066C17.4228 13.3178 17.5115 13.5498 17.486 13.8251C17.4598 14.1001 17.3292 14.3141 17.194 14.3034C17.0591 14.2922 16.9708 14.0601 16.9963 13.7852ZM29.8089 26.9886C29.8007 27.2806 29.5618 27.5129 29.2694 27.5129H10.5584C10.2612 27.5123 10.0199 27.2714 10.0193 26.9739V25.2397H29.8573L29.8089 26.9886ZM29.9005 23.6793H10.0258C10.0236 23.679 10.0216 23.678 10.0193 23.6777V21.2548H29.968L29.9005 23.6793ZM29.9886 20.5844H10.055L10.0265 20.5523C10.0242 20.5494 10.0216 20.5425 10.0193 20.5389V19.8757L10.0177 19.8554C10.0099 19.7605 10.0056 19.657 10.0059 19.5455C10.0052 18.9762 10.1165 18.2126 10.3925 17.3606C10.6681 16.5079 11.107 15.5645 11.7571 14.6189C12.3286 13.7861 13.143 13.1227 13.9682 12.6759C14.3803 12.4523 14.794 12.2827 15.175 12.1708C15.5557 12.0585 15.905 12.0052 16.1766 12.0055C16.4362 12.0038 16.6182 12.0581 16.6912 12.1053L16.8509 12.2068C16.0424 12.9059 15.3377 14.1305 15.3377 15.9056C15.3377 18.3065 17.3138 18.8666 18.431 18.8666C19.5481 18.8666 21.5242 18.3065 21.5242 15.9056C21.5242 15.6375 21.5032 15.3861 21.4731 15.1429L29.9732 20.5415L29.9892 20.5677L29.9912 20.5739L29.9886 20.5844ZM16.6169 16.1007C16.4834 16.1203 16.3377 15.9144 16.2922 15.6418C16.2464 15.3685 16.3184 15.1318 16.4523 15.1125C16.5862 15.0929 16.7318 15.2984 16.7776 15.5714C16.8228 15.8447 16.7511 16.0814 16.6169 16.1007Z',
    ],
    likeList: [
      { value: 'b2', text: 'Bubble Tea', },
      { value: 'c1', text: 'Cheese Cake', },
      { value: 'c3', text: 'Chocolate', },
      { value: 'c2', text: 'Cream Puff', },
      { value: 'd1', text: 'Donut', },
      { value: 'i1', text: 'Ice Cream', },
      { value: 'j2', text: 'Juice', },
      { value: 'm1', text: 'Matcha', },
      { value: 'p4', text: 'Pancakes', },
      { value: 'p3', text: 'Pudding', },
      { value: 's1', text: 'Shaved Ice', },
      { value: 't1', text: 'Taiyaki', },
      { value: 'sa', text: 'Smoothy', },
      { value: 'w4', text: 'Waffles', },
      { value: 'w3', text: 'Wagashi', },
      { value: 'o4', text: 'Other', },
    ],
  },{
    value: 'Food',
    text: 'Food',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: [
      'M17 17H19V11C19 10.45 19.45 10 20 10C20.55 10 21 10.45 21 11V17C21 19.21 19.21 21 17 21V29C17 29.55 16.55 30 16 30C15.45 30 15 29.55 15 29V21C12.79 21 11 19.21 11 17V11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11V17H15V11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11V17ZM26 22C24.9 22 24 21.1 24 20V14C24 12.51 25.6 10.68 27.76 10.15C28.39 10 29 10.48 29 11.13V29C29 29.55 28.55 30 28 30C27.45 30 27 29.55 27 29V22H26Z',
    ],
    likeList: [
      { value: 'b6', text: 'Bakery', },
      { value: 'b7', text: 'BBQ / Yakiniku', },
      { value: 'b8', text: 'Brunch', },
      { value: 'c5', text: 'Coffee', },
      { value: 'c6', text: 'Craft Beer', },
      { value: 'c4', text: 'Curry', },
      { value: 'd3', text: 'Dim Sum', },
      { value: 'i2', text: 'Irish Pub', },
      { value: 'j1', text: 'Japanese Sake', },
      { value: 'l1', text: 'Local Cusine', },
      { value: 'o1', text: 'Okonomiyaki', },
      { value: 'o2', text: 'Oyster', },
      { value: 'r1', text: 'Ramen', },
      { value: 'sb', text: 'Spicy Food', },
      { value: 's4', text: 'Standing Bar', },
      { value: 's5', text: 'Street Food', },
      { value: 's3', text: 'Sushi', },
      { value: 't2', text: 'Tea', },
      { value: 'v1', text: 'Vegan Food', },
      { value: 'w5', text: 'Wine / Winery', },
      { value: 'o5', text: 'Other', },
    ],
  },{
    value: 'Sports',
    text: 'Sports',
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: [
      'M22.4875 12.7087C23.5875 12.7087 24.4875 11.8087 24.4875 10.7087C24.4875 9.60874 23.5875 8.70874 22.4875 8.70874C21.3875 8.70874 20.4875 9.60874 20.4875 10.7087C20.4875 11.8087 21.3875 12.7087 22.4875 12.7087ZM12.2375 25.9587C11.8275 26.3687 11.8275 27.0487 12.2375 27.4587C12.6475 27.8687 13.3275 27.8687 13.7375 27.4587L16.4875 24.7087H18.4875L15.9875 22.2087L12.2375 25.9587ZM25.7775 25.9987L27.7775 28.0087C28.1675 28.3987 28.1675 29.0387 27.7775 29.4187L26.1975 30.9987C25.7975 31.3887 25.1675 31.3887 24.7775 30.9987L22.7875 28.9887C22.5975 28.8087 22.4975 28.5487 22.4975 28.2887V27.2087L15.3875 20.1187C15.0975 20.1587 14.7975 20.1887 14.4875 20.1887C13.8875 20.1887 13.4075 19.7087 13.4075 19.1087C13.4075 18.5087 13.8875 18.0287 14.4875 18.0287C16.1475 18.0587 18.0975 17.1587 19.1575 15.9887L20.5575 14.4387C20.7475 14.2287 20.9875 14.0587 21.2475 13.9387C21.5375 13.7987 21.8675 13.7087 22.2075 13.7087H22.2275C23.4675 13.7087 24.4875 14.7287 24.4875 15.9687V21.7187C24.4875 22.5587 24.1375 23.3287 23.5675 23.8787L19.9875 20.2987V18.0287C19.3575 18.5487 18.4875 19.0887 17.6975 19.4187L23.9875 25.7087H25.0675C25.3375 25.7087 25.5975 25.8187 25.7775 25.9987Z',
    ],
    likeList: [
      { value: 'b9', text: 'Badminton', },
      { value: 'b1', text: 'Batting Cage', },
      { value: 'b3', text: 'Bouldering', },
      { value: 'c7', text: 'Cycling', },
      { value: 'd2', text: 'Dancing', },
      { value: 'f1', text: 'Futsal', },
      { value: 'k4', text: 'Karate', },
      { value: 'r2', text: 'Rugby', },
      { value: 's7', text: 'Skiing', },
      { value: 's8', text: 'Snowboarding', },
      { value: 'se', text: 'SUP', },
      { value: 's6', text: 'Surfing', },
      { value: 't3', text: 'Table Tennis', },
      { value: 'w1', text: 'Watch Baseball', },
      { value: 'w6', text: 'Watch Basketball', },
      { value: 'w2', text: 'Watch Soccer', },
      { value: 'o6', text: 'Other', },
    ],
  },{
    value: 'Fun',
    text: 'Fun',
    fillRule: '',
    clipRule: '',
    d: [
      'M22.1333 12.7172C23.4204 13.0009 24.6936 12.1873 24.9773 10.8999C25.261 9.61283 24.4474 8.33998 23.1603 8.05634C21.8733 7.77303 20.6001 8.58584 20.3163 9.87289C20.0331 11.1603 20.8466 12.4336 22.1333 12.7172Z',
      'M29.7715 16.8467C29.8351 16.6182 29.8043 16.3736 29.6867 16.1673L29.6544 16.1108C29.4169 15.6946 28.8924 15.5411 28.4679 15.764L28.3133 15.8449L27.9506 15.0889C28.155 14.7196 28.1763 14.2592 27.9645 13.8587C27.631 13.2298 26.8502 12.9895 26.2205 13.3237C25.5912 13.6571 25.3517 14.4379 25.6851 15.0669C25.8974 15.467 26.2904 15.7076 26.7102 15.7459L27.1296 16.4652L25.7333 17.1971L22.4908 14.2817C22.2352 13.9716 21.534 13.5021 21.1355 13.3395C21.0645 13.3108 20.9927 13.2859 20.9209 13.2634C20.9209 13.2634 20.7607 13.2144 20.5839 13.1856L14.8329 12.2506C14.5018 12.1906 14.1605 12.2474 13.8666 12.4111L11.1437 13.9337C10.7405 14.1586 10.5953 14.6672 10.8186 15.0716L10.8296 15.0917C11.0304 15.4567 11.4681 15.6185 11.8583 15.4728L14.7649 14.3882L17.6606 15.3142L15.6223 20.2411L13.5095 25.5858L10.4149 30.1417C10.065 30.6034 10.1427 31.2591 10.5913 31.6265L10.6236 31.6521C11.0734 32.0198 11.7339 31.9638 12.1158 31.5262L14.1746 29.0867C14.4887 28.7103 15.5161 27.6071 15.7086 27.1565L17.9079 24.0146L21.5213 26.9994L20.3869 30.5583C20.2114 31.1107 20.4966 31.7041 21.0384 31.9117L21.0786 31.9275C21.6263 32.137 22.241 31.8778 22.4738 31.3408L24.1617 27.3616C24.9027 26.0825 24.1617 25.0724 23.6227 24.6009L20.7231 21.5541L22.2848 18.3274L24.4706 19.5718C24.8604 19.8259 25.8219 19.661 26.228 19.433L28.1313 18.1838L28.7662 19.2732L29.7163 18.7697L29.1233 17.5336L29.349 17.3852C29.5557 17.2696 29.708 17.0751 29.7715 16.8467Z',
    ],
    likeList: [
      { value: 'a3', text: 'Amusement Arcade', },
      { value: 'a1', text: 'Anime', },
      { value: 'a4', text: 'Architecture', },
      { value: 'a2', text: 'Art Museum', },
      { value: 'ba', text: 'Baking', },
      { value: 'bb', text: 'Beekeeping', },
      { value: 'b5', text: 'Board Game', },
      { value: 'b4', text: 'Bowling', },
      { value: 'c9', text: 'Camera', },
      { value: 'ca', text: 'Camping', },
      { value: 'cb', text: 'Caving', },
      { value: 'c8', text: 'Coding', },
      { value: 'cc', text: 'Composing', },
      { value: 'd4', text: 'Disney', },
      { value: 'f2', text: 'Fashion', },
      { value: 'h2', text: 'Fishing', },
      { value: 'h1', text: 'Hiking', },
      { value: 'i3', text: 'Illustrating / Drawing', },
      { value: 'k1', text: 'Karaoke', },
      { value: 'k2', text: 'Kendama', },
      /*{ value: 'm2', text: 'Manga', },*/
      { value: 'k3', text: 'Knitting', },
      { value: 'p5', text: 'Playing Bass', },
      { value: 'p6', text: 'Playing Guiter', },
      { value: 'p1', text: 'Pokemon', },
      { value: 't5', text: 'Restroom', },
      { value: 's2', text: 'Sento/Onsen', },
      { value: 's9', text: 'Shrine/Temple', },
      { value: 'sc', text: 'Songwriting', },
      { value: 'sd', text: 'Spending time on the beach', },
      { value: 't4', text: 'Taiko', },
      { value: 'v2', text: 'Video Game', },
      { value: 'v3', text: 'Visiting Castles', },
      { value: 'w7', text: 'Watch movies', },
      { value: 'y1', text: 'Yoga', },
      { value: 'o3', text: 'Other', },
    ],
  }],
  log(msg) {
    if (console) {
      console.log(msg)
    }
  }
};

export default service
